import { ReactNode, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface RouteScrollToTopProps {
  children: ReactNode;
}

export const RouteScrollToTop = ({ children }: RouteScrollToTopProps) => {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  return <>{children}</>;
};
